
  import Vue, {PropType} from "vue";
  import PwaIcon from "@/components/common/PwaIcon.vue";
  import PwaPrice from "@/components/common/PwaPrice.vue";

  export default Vue.extend({
    name: "pwa-competition-awards-tree",
    components: {
      PwaIcon,
      PwaPrice,
    },
    props: {
      pyramid: {
        type: Object,
        required: true,
      },
      dateRounds: {
        type: Array as PropType<any[]>,
        required: false,
        default: null,
      },
    },
    computed: {
      groupedAward(): any[] {
        const pyramid = this.pyramid ? Object.keys(this.pyramid) : [];
        const grouped: any[] = [];

        pyramid.forEach(round => {
          const numRows = this.isMobile ? 2 : 3;
          const award = this.pyramid[round];
          const value = {award, round};
          const numItems = grouped.length;
          const prevGroupedItems = numItems === 0 ? [] : grouped[numItems - 1];
          const isPrevItemCompleted = prevGroupedItems.length >= numRows;
          if (isPrevItemCompleted) {
            grouped.push([value]);
          } else {
            prevGroupedItems.push(value);
            if (numItems === 0) {
              grouped.push(prevGroupedItems);
            }
          }
        });

        return grouped;
      },
    },
    methods: {
      isRowReverse(index: number): boolean {
        const lastRow = this.isLastRow(index);
        const oddRow = this.isOddRow(index);

        return lastRow && index > 0 ? ((this.groupedAward[index - 1][1] ? oddRow : !oddRow)) : oddRow;
      },
      isFirstRow(index: number): boolean {
        return index === 0;
      },
      isLastRow(index: number): boolean {
        return (index + 1) === this.groupedAward.length;
      },
      isOddRow(index: number): boolean {
        return index % 2 !== 0;
      },
      formatDateRound(round: number): string {
        let date = '';
        if (this.dateRounds) {
          const dateRound = this.dateRounds[round - 1];
          if (dateRound && dateRound.datetime) {
            date = this.formatUserTime(dateRound.datetime);
          }
        }

        return date;
      },
    },
  });
